import Model from "../../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../../Styles/InputStyles";

const CancelReservation = ({
    setIsCancelReservation,
    selectedData,
    cancelReservationLoading,
    cancelReservationMutate,
}) => {
    const handleCancelSubmit = () => {
        cancelReservationMutate({ tenantId: selectedData?.data?.id || selectedData?.tenantId });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsCancelReservation}
            title="Reservation Cancellation Confirmation"
        >
            <WarningText>
                Please confirm if you wish to cancel the scheduled reservation process.
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsCancelReservation(false)}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleCancelSubmit}
                    disabled={cancelReservationLoading}
                    className="border border-rose-600 bg-white text-rose-600 hover:bg-rose-600 hover:text-white"
                >
                    {cancelReservationLoading ? "Processing..." : "Cancel Reservation"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default CancelReservation;
